<template>
    <div id="cadastro-screen">
        <termoAceiteCadastro @resposta="respostaAceite"></termoAceiteCadastro>
        <politicaPrivacidade @resposta="respostaPoliticaPrivacidade"></politicaPrivacidade>
        <div :class="'loading ' + (loadingLogin?'d-flex':'d-none')">
            <div :class="'box-loading ' + (loadingLogin?'d-flex':'d-none')">Cadastro Simplificado realizado, você será encaminhado para a tela de login</div>
            <b-spinner
                variant="primary"
                style="width: 20px; height: 20px"
                label="Large Spinner"
                v-if="loadingLogin"
            ></b-spinner>
        </div>
        <div class="d-flex align-items-center justify-content-center flex-column cadastro-container">
            <h1>Novo Cadastro</h1>
            <h3>Para ter acesso a protesto, Autorização de Cancelamento (Carta de anuência eletrônica) e outros serviços:</h3>
            <!-- MEUS DADOS -->
            <b-alert variant="danger" class="text-center" :show="erro" fade>{{ erro_msg }}</b-alert>
            <b-form-group label="Nome completo:" label-for="nome">
                <b-form-input id="nome" v-model="form.nome" placeholder="Seu nome" trim :disabled="loading"></b-form-input>
            </b-form-group>
            <b-form-group label="CPF/CNPJ:" label-for="cpf_cnpj">
            <the-mask
                :mask="[maskCPF, maskCNPJ]"
                id="cpf_cnpj"
                v-model="form.cpf_cnpj"
                class="form-control"
                @blur.native="validaDoc"
                @input="clearCpfCnpj"
                :placeholder="(isCnpj?'12.345.678/0001-91':'123.456.789-01')"
                :disabled="loading"
            />
            </b-form-group>
            <b-form-group label="E-mail:" label-for="email">
                <b-form-input 
                    id="email"
                    v-model="form.email"
                    type="email"
                    trim
                    @blur.native="validaEmail"
                    placeholder="email@exemplo.com.br"
                    autocomplete="off"
                    :disabled="loading"></b-form-input>
            </b-form-group>
            <b-form-group label="Contato:" label-for="telefone">
                <the-mask
                    :mask="['(##) ####-####', '(##) #####-####']"
                    id="telefone"
                    v-model="form.telefone"
                    class="form-control"
                    placeholder="(XX) XXXXX-XXXX"
                    :disabled="loading"
                />
            </b-form-group>
            <b-form-group label="Senha:" label-for="senha">
                <b-form-input id="senha" type="password" aria-describedby="input-live-feedback" v-model="form.senha" @blur.native="validaPass" placeholder="********" autocomplete="off" :disabled="loading"></b-form-input>
            </b-form-group>
            <b-form-group>
                <b-form-checkbox
                    id="termoUso"
                    v-model="form.termoUso"
                    name="termoUso"
                    stacked
                    :value="true"
                    :unchecked-value="false"
                >Li e aceito os Termos de Uso do Site Cenprot</b-form-checkbox>
            </b-form-group>
            <b-form-group>
                <b-form-checkbox
                    id="politicaPrivacidade"
                    v-model="form.politicaPrivacidade"
                    name="politicaPrivacidade"
                    stacked
                    :value="true"
                    :unchecked-value="false"
                >Li e aceito a Política de Privacidade da Cenprot.</b-form-checkbox>
            </b-form-group>
            <span class="mb-2" @click="mostraTermoUso" style="color:#597EB5;cursor:pointer;text-decoration: underline;font-weight: bold;">Termos de Uso</span>
            <span class="mb-2" @click="mostraPoliticaPrivacidade" style="color:#597EB5;cursor:pointer;text-decoration: underline;font-weight: bold;">Política de Privacidade</span>

            <b-alert :show="alertDocInvalido" fade variant="danger" class="text-center">Documento informado inválido!</b-alert>
            <b-alert :show="alertEmailInvalido" fade variant="danger" class="text-center">E-mail informado inválido!</b-alert>
            <b-alert :show="alertUserExists" fade variant="danger" class="text-center">Usuário já cadastrado.<br/>Para reativar seu acesso, entre em contato com o suporte</b-alert>
            <b-alert :show="alertEmailExists" fade variant="danger" class="text-center">Já encontra-se usuário cadastrado com o e-mail informado!</b-alert>
            <b-alert :show="alertEmailForbidden" fade variant="danger" class="text-center">Houve um erro ao validar e-mail informado!</b-alert>
            <b-alert :show="alertPassBasic" fade variant="danger" class="text-center">A senha deve conter ao menos 8 caracteres, <br/> uma maiúscula, uma minúscula, <br/> um caracter especial e um número.</b-alert>

            <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="sitekey">
            </vue-recaptcha>

            <b-button id="btn-cadastrar"  @click="continuar()" variant="primary" class="btn-lg float-right" block :disabled="validForm"><b-spinner id="loading-cadastrar" small type="grow" v-if="loading"></b-spinner> Cadastrar</b-button>
        </div>
    </div>
  </template>
  
  <script>
  import axios from "axios"
  import { TheMask } from "vue-the-mask"
  
  import Serv from '@/services'
  import API from '@/services/api'
  import VueRecaptcha from 'vue-recaptcha'
  import termoAceiteCadastro from "@/components/modal/TermoAceiteCadastro";
  import politicaPrivacidade from "@/components/modal/politicaPrivacidade";
  
    
  
export default {
    components: {
        VueRecaptcha,
        TheMask,
        termoAceiteCadastro,
        politicaPrivacidade
    },
    props: {
    },
    methods: {
        respostaAceite: function ( resposta ){
            // this.icTermoAceite = resposta.respostaFinal == 's' ?  1 : 0
            this.form.termoUso = resposta.respostaFinal == 's'
        },
        respostaPoliticaPrivacidade: function ( resposta ){
            this.form.politicaPrivacidade = resposta.respostaFinal == 's'
        },
        onVerify: function (response) {
            let bt = document.getElementById('btn-cadastrar');
            this.tok = response
            this.$refs.invisibleRecaptcha.reset();
            if(response != ''){
                this.loading = true
                bt.disabled = true
                const { nome, email, cpf_cnpj, telefone, senha, termoUso, politicaPrivacidade } = this.$data.form; 
                const { tok } = this.$data;

                const dados = { nome, email, cpf_cnpj, telefone, senha, tok, termoUso, politicaPrivacidade }

                let self = this

                // cadastra dados do usuário
                API.post('usuario/simples', dados).then((res) => {
                    this.loading = false;
                    if(res.data.cadastrado === true){
                        this.loadingLogin = true;
                        
                        if (self.$route.params.redirect_uri) {
                            self.$router.push({ 
                                name: "login-sso", 
                                query: {
                                    client_id: this.$route.params.client_id,
                                    redirect_uri: this.$route.params.redirect_uri,
                                    state: this.$route.query.state
                                }
                            });
                        }
                        else if(this.$route.query.redirect_uri){
                            self.$router.push({ 
                                name: "login-sso", 
                                query: {
                                    client_id: this.$route.query.client_id,
                                    redirect_uri: this.$route.query.redirect_uri,
                                    state: this.$route.query.state
                                }
                            });
                        }
                        else{
                            
                            this.$root.login(cpf_cnpj, senha, tok).then((res) => {
                                localStorage.setItem("jwtToken", res.token);
                                sessionStorage.setItem("jwtToken", res.token);
                                localStorage.setItem("usrName", res.name);
                                localStorage.setItem("usrEmail", res.email);
                                localStorage.setItem("usrCpf", res.cpf);
                                
                                self.cadastrado_concluido = true;
                                setTimeout(function() {
                                    this.loadingLogin = false;
                                }, 10000);
                                
                                this.$emit('cadastropesquisa', {resposta:true});
                            }).catch((res) => {
                                this.resetRecaptcha()
                                if (res.error === 1) this.erro_msg = 'Erro ao realizar o login';
                                else this.erro_msg = 'Erro ao realizar o login.';
                                this.erro = true;
                                this.loadingLogin = false;
                            });
                        }
                    }
                    else{
                        this.erro_msg = res.data.message;
                        this.erro = true;
                        this.loadingLogin = false;
                    }
                });
            }
            this.resetRecaptcha()
        },
        resetRecaptcha () {
            this.$refs.invisibleRecaptcha.reset() // Direct call reset method
        },
        onExpired: function () {
            this.$refs.invisibleRecaptcha.reset()
        },
        cadastrar() {
            this.$refs.invisibleRecaptcha.execute()
        },
        continuar() {
            // if(this.icTermoAceite == 0)this.$bvModal.show('modal-conf')
            if(this.validar()) {
                if(!this.validaDoc()) {
                    document.getElementById('cpf_cnpj').parentNode.parentNode.classList.add("is-invalid")
                    document.getElementById('cpf_cnpj').classList.add("is-invalid")
                    return
                }
                if(!Serv.validarEmail(this.form.email)) {
                    document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                    document.getElementById('email').classList.add("is-invalid")
                    return
                }
                if(this.alertEmailExists || this.alertEmailForbidden){
                    document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                    document.getElementById('email').classList.add("is-invalid")
                    return
                }
                this.cadastrar()
                return
            }
            else return false;
        },
        validar() {
            let self = this
            let erros = 0
            let campos = []
            if(this.isInvalid('telefone', this.form.telefone)) campos = ['nome', 'cpf_cnpj', 'email', 'senha', 'telefone', 'termoUso', 'politicaPrivacidade'];
            else campos = ['nome', 'cpf_cnpj', 'email', 'senha', 'termoUso', 'politicaPrivacidade'];

            // verifica campos
            campos.forEach((campo) => {
                erros += self.isInvalid(campo, self.form[campo]) ? 1 : 0
            });

            // erros += !this.icTermoAceite

            return erros > 0 ? false : true
        },
        isInvalid(field, value) {
            if ((!value) || (value == 'undefined')) {
                document.getElementById(field).parentNode.parentNode.classList.add("is-invalid");
                document.getElementById(field).classList.add("is-invalid");
            }
            else {
                document.getElementById(field).parentNode.parentNode.classList.remove("is-invalid");
                document.getElementById(field).classList.remove("is-invalid");
            }
            return value ? false : true;
        },
        validaDoc() {
            if(this.erro) {
                this.erro_msg = '';
                this.erro = false;
            }
            let len = this.form.cpf_cnpj.length, doc = this.form.cpf_cnpj
            let valid = false;
            let self = this;
            let bt = document.getElementById('btn-cadastrar');

            if(len < 11 || len > 14){
                document.getElementById('cpf_cnpj').parentNode.parentNode.classList.add("is-invalid");
                document.getElementById('cpf_cnpj').classList.add("is-invalid");
                self.alertDocInvalido = true;
                bt.disabled = true;
                // return 0;
            }
            else if(len === 11){
                valid = Serv.validarCPF(doc);
            }
            else {
                valid = Serv.validarCNPJ(doc)
            }
            if(valid){
                if(this.userExists()){
                    document.getElementById('cpf_cnpj').parentNode.parentNode.classList.add("is-invalid");
                    document.getElementById('cpf_cnpj').classList.add("is-invalid");
                    return 0;
                }
                else {
                    document.getElementById('cpf_cnpj').parentNode.parentNode.classList.remove("is-invalid");
                    document.getElementById('cpf_cnpj').classList.remove("is-invalid");
                    self.alertDocInvalido = false;
                    bt.disabled = false;
                    return 1;
                }
            }
            else{
                document.getElementById('cpf_cnpj').parentNode.parentNode.classList.add("is-invalid");
                document.getElementById('cpf_cnpj').classList.add("is-invalid");
                self.alertDocInvalido = true;
                bt.disabled = true;
                return 0;
            }
        },
        validaPass(){
            let self = this
            let bt = document.getElementById('btn-cadastrar')
            // eslint-disable-next-line
            const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@()$%^&*=_{}[\]:;\"'|\\<>,.\/~`±§+-]).{8,30}$/;
            const str = this.form.senha;
            // eslint-disable-next-line
            let m;
    
            if ((m = regex.exec(str)) !== null) {
                self.alertPassBasic = false
                bt.disabled = false
                /*m.forEach((match, groupIndex) => {
                    console.log(`Found match, group ${groupIndex}: ${match}`);
                }); */       
            } else {
                self.alertPassBasic = true
                bt.disabled = true        
            }   
        },
        async validaEmail() {
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            let valid = emailRegex.test(this.form.email);
            let self = this
            let bt = document.getElementById('btn-cadastrar')

            if(valid){
                const isForbidden = await this.emailForbidden();
                if(isForbidden){
                    self.alertEmailForbidden = true
                    self.alertEmailInvalido = true
                    bt.disabled = true
                    document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                    document.getElementById('email').classList.add("is-invalid")
                    return 0;
                }
                else{
                  self.alertEmailForbidden = false
                  self.alertEmailInvalido = false
                  bt.disabled = false
                  document.getElementById('email').parentNode.parentNode.classList.remove("is-invalid")
                  document.getElementById('email').classList.remove("is-invalid")
                }

                const emailExiste = await this.emailExists();
                if(emailExiste){
                    self.alertEmailExists = true
                    bt.disabled = true
                    document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                    document.getElementById('email').classList.add("is-invalid")
                }
                else{
                    self.alertEmailExists = false
                    self.alertEmailInvalido = false
                    bt.disabled = false
                    document.getElementById('email').parentNode.parentNode.classList.remove("is-invalid")
                    document.getElementById('email').classList.remove("is-invalid")
                    return 0;
                }
            }
            else {
                self.alertEmailInvalido = true
                bt.disabled = true
                document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                document.getElementById('email').classList.add("is-invalid")
                return 0;
            }            
        },
        userExists() {
            if(this.form.cpf_cnpj !== null && this.form.cpf_cnpj !== ''){
                let self = this
                let bt = document.getElementById('btn-cadastrar')
                API.get(`usuario/doc/${this.form.cpf_cnpj}`).then((res) => {
                    if(res.data.exists === true) {
                        document.getElementById('cpf_cnpj').parentNode.parentNode.classList.add("is-invalid");
                        document.getElementById('cpf_cnpj').classList.add("is-invalid");
                        self.alertUserExists = true
                        bt.disabled = true
                    } else {
                        document.getElementById('cpf_cnpj').parentNode.parentNode.classList.remove("is-invalid");
                        document.getElementById('cpf_cnpj').classList.remove("is-invalid");
                        self.alertUserExists = false
                        bt.disabled = false
                    }
                    return res.data.exists;
                })
            }
        },
        emailExists() {
            return new Promise((resolve, reject) => {
                let self = this
                const dados = { email: this.form.email };
                if (this.form.email){
                    API.post(`usuario/email`,dados).then((res) => {
                        resolve(res.data.exists);
                    });
                }
                else throw new Error(false);
            });
        },
        async emailForbidden() {
          return new Promise((resolve, reject) => {
            if (this.form.email) {
              const dados = { email: this.form.email };
              API.post(`usuario/email/blacklist`, dados).then((res) => {
                resolve(res.data.isForbidden);
              }).catch((error) => {
                console.error('Erro checagem email valido');
                resolve(false);
              });
            } else {
              resolve(false);
            }
          });
        },
        mostraTermoUso(){
            this.$bvModal.show('modal-conf');
        },
        mostraPoliticaPrivacidade(){
            this.$bvModal.show('modal-politica-privacidade');
        },
        clearCpfCnpj(){
            if(this.erro) {
                this.erro_msg = '';
                this.erro = false;
            }
            if(this.alertUserExists){
                this.alertUserExists = false;
                document.getElementById('cpf_cnpj').parentNode.parentNode.classList.remove("is-invalid");
                document.getElementById('cpf_cnpj').classList.remove("is-invalid");
            }
            if(this.alertDocInvalido){
                this.alertDocInvalido = false;
                document.getElementById('cpf_cnpj').parentNode.parentNode.classList.remove("is-invalid");
                document.getElementById('cpf_cnpj').classList.remove("is-invalid");
            }
        }
    },  
    computed: {
        cpfcnpj(){
            return this.form.cpf_cnpj;
        },
        pass(){
            return this.form.senha;
        },
        validForm: function(){
            let invalidFields =  ( this.alertDocInvalido || this.alertEmailInvalido ||
                        this.alertUserExists || this.alertEmailExists||
                        this.alertEmailForbidden || this.alertPassBasic);
            let notFilledFields = ( this.form.nome === '' 
                                    || this.form.cpf_cnpj === ''
                                    || this.form.email === ''
                                    || this.form.telefone === '' 
                                    || this.form.senha=== '' 
                                    || !this.form.termoUso 
                                    || !this.form.politicaPrivacidade );
            return invalidFields || notFilledFields;
        }
    },
    watch: {
        cpfcnpj(cpfcnpj){
            let removeFormatacao = cpfcnpj.replace(["-",".","/"], "");
            if(removeFormatacao.length==14 || removeFormatacao.length==11){
                this.validaDoc()
            }
            // if(removeFormatacao.length==14)this.isCnpj = true;
            // if(removeFormatacao.length==11)this.isCnpj = false;
        },
        pass(senha){
            if(this.alertPassBasic){
                this.validaPass();
            }
        }            
    },
    data() {
        return {
            sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
            loading: false,
            loadingLogin: false,
            cadastrado_concluido: false,
            form:{
                nome: "",
                cpf_cnpj: "",
                email: "",
                telefone: "",
                senha: "",
                termoUso: false,
                politicaPrivacidade: false
            },
            maskCPF: '###.###.###-##',
            maskCNPJ: '##.###.###/####-##',
            isCnpj:'',
            alertDocInvalido: false,
            alertEmailInvalido: false,
            alertUserExists: false,
            alertEmailExists: false,
            alertEmailForbidden: false,
            alertPassBasic:false,
            tok: '',
            erro_msg:'',
            erro:false,
            // icTermoAceite:0,
        }
    },
  }
  </script>
  
<style scoped>
    #cadastro-screen {
        padding: 38px 76px 38px 74px;
    }
    #cadastro-screen h1{
        text-align: center;
        font: normal normal bold 25px/30px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        margin-bottom: 18px;
    }
    #cadastro-screen h2{
        text-align: left;
        font: normal normal bold 25px/34px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
    }
    #cadastro-screen h3{
        text-align: center;
        font: normal normal normal 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        margin-bottom: 50px;
    }
    .alert.text-center.alert-danger {
        font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
        letter-spacing: 0px;
    }
    #cadastro-screen button#btn-cadastrar{
        min-width: 150px;
        height: 42px !important;
        width: 100%;
        background: #597EB5 0% 0% no-repeat padding-box !important;
        border: 3px solid #597EB5 !important;
        border-radius: 5px !important;
        padding: 0 !important;
        text-align: center;
        font: normal normal bold 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #FFFFFF;
        margin-top: calc(35px - 17px);
    }
    #cadastro-screen input::placeholder{
        color: #A8A8A8;
    }
    #cadastro-screen input:focus{
        box-shadow: none;
    }
    #cadastro-screen .is-invalid label{
        color:#1ACEB5 !important;
    }
    #cadastro-screen .is-invalid{
        border-color: #1ACEB5;
    }
    #cadastro-screen input{
        background: #F1F1F1 0% 0% no-repeat padding-box;
        border: 1px solid #FFFFFF;
        border-radius: 5px;
        text-align: left;
        font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
        letter-spacing: 0px;
    }
    #cadastro-screen .form-group{
        text-align: left;
        font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
        letter-spacing: 0px !important;
        color: #597EB5 !important;
        margin-bottom: 17px;
        width: 100%;
    }
    #loading-cadastrar {
        vertical-align: 0;
        margin-left: -21px;
    }
    .cadastro-container{
        width: 303px;
        margin: 0 auto;
    }
    .alert.alert-danger{
        width:100%;
        background: #F8CBCB 0% 0% no-repeat padding-box;
        color: #702727;
        font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
        text-decoration: none;
    }
    .loading {
        width: 100vw;
        height: 100vh;
        position: fixed;
        background: #000000ab;
        top: 0;
        left: 0;
        z-index: 10000;
        align-items: center;
        justify-content: center;
    }
    .loading .box-loading{
        width: 300px;
        height: 200px;
        border-radius: 20px;
        background: #ffffff;
        position: fixed;
        text-align: center;
        align-items: end;
        padding: 20px 30px;
        margin-top: 50px;
        font: normal normal normal 18px/20px 'Kanit', sans-serif !important;

    }
</style>
  